export default function Navbar() {
    return (
        <nav className="h-[60px] w-full flex justify-center items-center font-bold border-b-1 text-4xl">Wordle</nav>
    )
}